import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { intercept } from 'mobx';
import { propertyDecorator } from 'decorating';
import { attachInitializer } from '../utils';
export default propertyDecorator(function (target, prop, desc, handler) {
  if (!handler) throw new Error("@intercept must be called with handler argument");
  attachInitializer(target, prop, function (store) {
    intercept(store, prop, handler.bind(store));
  });
  return desc && _objectSpread({}, desc, {
    configurable: true
  });
});